<div class="range-filter">
  <div class="range" fxLayout="column" fxFlex="100" fxLayoutAlign="center center">
    <div class="range__desktop-inputs" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="range__desktop-inputs__item">
        <mm-label
          class="range__desktop-inputs__item__label"
          for="mm-input-range-min-input"
          [attr.aria-label]="attributeName + ' ' + ('CATALOG.CATALOG_PAGE.FILTERS.PRICE.MIN' | translate)"
        >
          {{ 'CATALOG.CATALOG_PAGE.FILTERS.PRICE.MIN' | translate }}
        </mm-label>
        <mm-field class="range__desktop-inputs__item__field">
          <input
            id="range-min-input"
            mmInput
            type="number"
            [value]="from"
            [min]="min"
            [max]="max"
            inputmode="numeric"
            (change)="onFromChange($event)"
          />
        </mm-field>
      </div>
      <div class="range__desktop-inputs__dash" fxLayoutAlign="center center">
        <span>-</span>
      </div>
      <div class="range__desktop-inputs__item">
        <mm-label
          class="range__desktop-inputs__item__label"
          for="mm-input-range-max-input"
          [attr.aria-label]="attributeName + ' ' + ('CATALOG.CATALOG_PAGE.FILTERS.PRICE.MAX' | translate)"
        >
          {{ 'CATALOG.CATALOG_PAGE.FILTERS.PRICE.MAX' | translate }}
        </mm-label>
        <mm-field class="range__desktop-inputs__item__field">
          <input
            mmInput
            type="number"
            id="range-max-input"
            [value]="to"
            [min]="min"
            [max]="max"
            inputmode="numeric"
            (change)="onToChange($event)"
          />
        </mm-field>
      </div>
    </div>
  </div>
</div>
